import React, { useState } from "react";
import { useAuth } from "../../lib/auth";
import SEO from "../../components/SEO";
import { Lock, LogIn, AlertCircle } from "lucide-react";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(password);
    } catch (err) {
      setError(err.message || "خطای ناشناخته");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <SEO title="ورود مدیر | تحسین" />
      <section className="min-h-[80vh] flex items-center justify-center px-4 py-14" data-testid="admin-login-page">
        <div className="w-full max-w-md bg-white border border-stone-200 rounded-3xl shadow-lg p-8 text-right">
          <div className="w-14 h-14 rounded-2xl honey-gradient flex items-center justify-center mx-auto mb-4">
            <Lock className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-2xl font-black text-stone-900 text-center mb-1">ورود به پنل مدیریت</h1>
          <p className="text-sm text-stone-500 text-center mb-7">رمز عبور خود را وارد کنید</p>

          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-sm font-medium text-stone-700 mb-2">رمز عبور</label>
              <div className="relative">
                <Lock className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoFocus
                  placeholder="••••••••"
                  className="w-full pr-10 pl-4 py-3 rounded-xl bg-stone-50 border border-stone-200 focus:border-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-600/20"
                  data-testid="admin-login-password"
                />
              </div>
            </div>

            {error && (
              <div className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm" data-testid="admin-login-error">
                <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={busy}
              className="w-full inline-flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 rounded-xl transition-colors disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              <LogIn className="w-4 h-4" />
              {busy ? "در حال ورود..." : "ورود"}
            </button>
          </form>

          <p className="mt-6 text-xs text-stone-500 text-center leading-relaxed">
            کلیدهای R2 با PBKDF2 و AES-GCM رمزنگاری شده‌اند و فقط در مرورگر شما رمزگشایی می‌شوند.
          </p>
        </div>
      </section>
    </>
  );
}
